import { BsMetaUtil, formatLeverage, isExponentLoop, isRatexLoop, LoopExpanded } from "@bridgesplit/abf-react";
import { EventAvailableOutlined, TuneOutlined, AutoGraphOutlined, AutoModeOutlined } from "@mui/icons-material";
import { LoopRouteType } from "@bridgesplit/abf-sdk";

import { OnboardingBullet } from "./constants";

export function generateMarketGuideBullets(loopExpanded: LoopExpanded | undefined): OnboardingBullet[] {
    if (!loopExpanded) return [];
    const collateralSymbol = BsMetaUtil.getSymbol(loopExpanded.collateralToken);
    const principalSymbol = BsMetaUtil.getSymbol(loopExpanded.principalToken);
    const multiplier = loopExpanded?.loopVault.maxLeverage;

    const leverageFormatted = formatLeverage(multiplier ?? 0);
    const protocol = (() => {
        switch (loopExpanded.loopVault.routeType) {
            case LoopRouteType.Exponent:
                return "Exponent";
            case LoopRouteType.Ratex:
                return "RateX";
            default:
                return "";
        }
    })();

    if (isExponentLoop(loopExpanded) || isRatexLoop(loopExpanded)) {
        return [
            {
                Icon: TuneOutlined,
                header: "Select leverage and deposit",
                text: `Choose up to ${leverageFormatted} leverage and deposit ${collateralSymbol}`
            },
            {
                Icon: AutoModeOutlined,
                header: `Increase your ${collateralSymbol} exposure`,
                text: `Borrow ${principalSymbol} to increase your ${collateralSymbol} exposure, swapping for ${collateralSymbol} at the ${protocol} market price`
            },
            {
                Icon: AutoGraphOutlined,
                header: `${collateralSymbol} appreciates as it reaches expiry`,
                text: `Buy ${principalSymbol} at a discount in the form of ${collateralSymbol}. The APY earned is inclusive of the fee if held to maturity`
            },
            {
                Icon: EventAvailableOutlined,
                header: "Close position at any time",
                text: `At the end of the term, 1 ${collateralSymbol} is redeemable for 1 ${principalSymbol}. In the interim, you may withdraw but the exchange rate + fees will vary`
            }
        ];
    }
    return [
        {
            Icon: TuneOutlined,
            header: "Select leverage and deposit",
            text: `Choose up to ${leverageFormatted} leverage and deposit ${collateralSymbol}`
        },
        {
            Icon: AutoModeOutlined,
            header: `Increase your ${collateralSymbol} exposure`,
            text: `Borrow ${principalSymbol} against your ${collateralSymbol} and swap it for more ${collateralSymbol}`
        },
        {
            Icon: AutoGraphOutlined,
            header: `Earn yield when ${collateralSymbol} outperforms ${principalSymbol}`,
            text: `Your position earns leveraged ${collateralSymbol} fees while borrowing ${principalSymbol} at fixed rates`
        },
        {
            Icon: EventAvailableOutlined,
            header: "Close position at any time",
            text: `To close, you'll swap your ${collateralSymbol} back to ${principalSymbol}, repay the loan, and keep any remaining ${collateralSymbol} as profit`
        }
    ];
}
